import React, { Component } from 'react'
import axios from 'axios'
import _ from 'lodash'
import { backendURL } from '../../data/config.json'

//Message Box
import Message from '../Message'

//Loader
import Loader from '../Loader'

//Recaptcha disabled for design purposes
import Reaptcha from 'reaptcha'

import imgAuto from '../../images/auto-lineas.png'

class EmailOffers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        type: props.type,
        title: props.title,
        email:''
      },
      loading: false,
      formIsValid: false,
      resText: '',
      sent: false,
      error: false,
      recaptcha: false,
      recaptchaFirstTime: true,
    }
    this.handleChange = this.handleChange.bind(this)
    // this.handleChangeRecaptcha = this.handleChangeRecaptcha.bind(this)
    this.handleHighlightEmptyValues = this.handleHighlightEmptyValues.bind(this)
    this.handleHighlightEmptyRecaptcha = this.handleHighlightEmptyRecaptcha.bind(
      this
    )
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentWillMount() {
    console.log(this.props.items)
    this.props.items.map((item, index) => {
      this.setState(prevstate => {
        return {
          ...prevstate,
          data: {
            ...prevstate.data,
            [item.node.fieldname]: '',
          },
        }
      })
    })
  }

  handleChange(event) {
    const { name, value } = event.target
    this.setState(prevstate => {
      return {
        ...prevstate,
        data: {
          ...prevstate.data,
          [name]: value,
        },
      }
    })
  }

  handleHighlightEmptyValues(value) {
    if (this.state.emptyValues && _.isEmpty(value)) {
      return 'inputNormal inputError'
    }
    return 'inputNormal'
  }

  handleHighlightEmptyRecaptcha(value) {
    if (!this.state.recaptcha && !this.state.recaptchaFirstTime) {
      return 'inputNormal inputError'
    }
    return 'inputNormal'
  }
  hasEmptyValue() {
    const { email } = this.state.data
    const emptyValues = _.some([email], value => value === '')
    if (emptyValues) {
      return true
    }
    return false
  }

  handleSubmit(event) {
    event.preventDefault()
    console.log(this.state.recaptcha)
    this.setState({
      recaptchaFirstTime: false,
    })
    // if (this.hasEmptyValue() || !this.state.recaptcha) {
    if (this.hasEmptyValue()) {
      this.setState({
        emptyValues: true,
        resText:
          this.props.lang === 'en'
            ? 'There are errors in the form. Please correct them and resubmit the form.'
            : 'Hay errores en el formulario. Corríjalos y vuelva a enviar el formulario.',
      })
    } else {
      this.setState({ emptyValues: false, loading: true })
      axios({
        method: 'post',
        data: this.state.data,
        url: `${backendURL}/api/contactForms/add`,
      })
        .then(res => {
          console.log(res)
          this.setState({
            loading: false,
            sent: true,
            resText:
              this.props.lang === 'en'
                ? 'Thank you. Your information has been sent'
                : 'Gracias. Tu información ha sido enviada',
          })
        })
        .catch(err => {
          this.setState({
            loading: false,
            error: true,
            resText:
              this.props.lang === 'en'
                ? 'Sorry we could not send your information. Please try later'
                : 'Lo sentimos, no pudimos enviar su información. Por favor intente mas tarde',
          })
          console.log(err)
        })
    }
  }

  renderText() {
    const { lang, items } = this.props
    return _.map(items, (item, i) => {
      const { title, description, button, inputPlaceholder, fieldname } = item.node
      return (
        <React.Fragment>
          <h2>{title[lang]}</h2>
          <input
            type="email"
            name={fieldname}
            placeholder={inputPlaceholder[lang]}
            onChange={this.handleChange}
            className={this.handleHighlightEmptyValues(
              this.state.data['email']
            )}
          />
          <button>{button[lang]}</button>
          <p>{description[lang]}</p>
        </React.Fragment>
      )
    })
  }

  render() {
    const { lang } = this.props

    //render message respond
    let respondField = null
    if (this.state.loading) {
      respondField = <Loader />
    }
    if (this.state.sent || this.state.error || this.state.emptyValues) {
      respondField = <Message text={this.state.resText} />
    }

    return (
      <form className="EmailOffers" onSubmit={this.handleSubmit}>
        {this.renderText()}
        {respondField}
        <img src={imgAuto} alt="Budget Email Offers" />

        {/* <div
          name="recaptcha"
          className={`recaptcha-class ${this.handleHighlightEmptyRecaptcha(
            'recaptcha'
          )}`}
        >
          <Reaptcha
            onVerify={this.handleChangeRecaptcha}
            sitekey="6LccKWsUAAAAAOALqGeqc33LprinhR3FnIlrKEX4"
          />
        </div> */}
      </form>
    )
  }
}
export default EmailOffers



// WEBPACK FOOTER //
// ./src/components/EmailOffers/index.js